import React from 'react';

const InvalidComponent = () => {
  return (
    <div>
      <h1>404 : Page Not Found</h1>
      <h3>
        Facing technical issue? connect with -{' '}
        <a
          href='https://www.linkedin.com/in/ranjan-kumar-m-818367158/'
          target='_blank'
          style={{ textDecoration: 'none' }}
        >
          Ranjan Kumar Mandal
        </a>
      </h3>
    </div>
  );
};

export default InvalidComponent;
